import { observer } from 'mobx-react';
import React from 'react';

import view from 'modules/ticketPublicPage/stores/tickets/view';
import { NoTicketsContainer } from './Common.styles';

const NoTicketsInfo = observer(() => {
  const {
    activeObject: { type },
  } = view;

  return (
    <NoTicketsContainer>
      <div>
        {i18n.gettext(
          'We are sorry, but there are currently no tickets available.'
        )}
      </div>
    </NoTicketsContainer>
  );
});

export default NoTicketsInfo;
